/* eslint-disable  @typescript-eslint/no-explicit-any */
import type {
  PipeMiddlewareElement,
  PipeMiddlewareNext,
} from '../../middleware-pipe';
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import type { SearchTab } from '../../../../components/result-page/search-tab/search-tab';
import type { CoseQueryBodyRequest } from '../../../../models/cose-api/request/query-body-request.model';
import { makeLogger } from '../../../../logger/logger';

const { debug } = makeLogger({
  pathToCurrentFile:
    'utils/middleware-pipe/pipes/cose/distributor-stock-invalid-ids.ts',
  loggersList: ['debug'],
});

export const distributorStockInvalidIds: PipeMiddlewareElement<
  MiddlewarePipeDetails,
  any
> = async (details: MiddlewarePipeDetails, next: PipeMiddlewareNext<any>) => {
    const searchTab: SearchTab = details.context;
    const response = await next(details);

    //Getting the products data can happen in parallel to the main flow,
    //so we don't block the main flow:
    (async () => {
    // request should be send only if checkDistributorStockInvalidIds is true (UiR props)
        const shouldRequestSent = searchTab?.checkDistributorStockInvalidIds;
        let term = searchTab.queryProp;
        if (!shouldRequestSent || !term) {
          return;
        }

        debug('Should a reference verification request be sent', { shouldRequestSent });

        const splitTerm = term.split(',');
        const terms = splitTerm.map((term) => {
            if (term.match(/\d+/g)) {
              const matches = term.match(/\d+/g);
              const productNumber = matches[matches.length - 1];
              return term.replace(` ${productNumber}`, '');
            }
        });

        term = terms.join(',');

        const requestBody: CoseQueryBodyRequest = {
          searcher: 'myschneider/stock/validation',
          country: searchTab.country,
          language: searchTab.language,
          term: term,
          forceTerm: false,
          facetsOptions: { fetch: false },
          sortOptions: { fetch: false },
          pagination: {
            limit: 1,
            offset: 0,
          },
        };

        const newDetais = {
          ...details,
          middlewareRequest: {
            ...details.middlewareRequest,
            middlewareSuffix: '-product-stock-validation',
            requestBody: {
              ...details.middlewareRequest.requestBody,
              ...requestBody,
            },
          },
        };

        const getResponse = async () => {
            const response = await next(newDetais);
            return response;
        };

        const res = await getResponse();
        document.dispatchEvent(
          new CustomEvent('search:distributor-stock-invalid-ids', {
            bubbles: true,
            detail: res.documents,
          }),
        );
    })();

    return new Promise((r) => r(response));
};
